package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.Serializable

@Serializable
data class ReasonRequest(
    val reason: String? = null,
)
